module.exports = __webpack_public_path__ + "static/media/Stephen.f0477456.png";